module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av536-7f8835e8666515fcad0062dbfda99552.jpg";